import React from "react";
import styled from "styled-components";
import { spacing } from "@material-ui/system";
import { CircularProgress as MuiCircularProgress } from "@material-ui/core";
const CircularProgress = styled(MuiCircularProgress)(spacing);

export default function ButtonProgress({ loading }) {
  if (!loading) return null;
  return <CircularProgress mr={2} size={16} color="inherit" />;
}